import { TimeSheetItem } from '../../../features/schedule/types';

export const filterTimesheetItems = (
    items: TimeSheetItem[] = [],
    search?: string,
    canViewInternalNote = true
): TimeSheetItem[] => {
    if (!items.length) {
        return items;
    }

    const trimmed = search?.trim().toLowerCase() ?? '';
    if (!trimmed) {
        return items;
    }

    return items.filter((item) =>
        item.employeeName.toLowerCase().includes(trimmed) ||
        item.targetName.toLowerCase().includes(trimmed) ||
        (item.note ?? '').toLowerCase().includes(trimmed) ||
        (canViewInternalNote && (item.internalNote ?? '').toLowerCase().includes(trimmed))
    );
};
